import { t as e } from "./cx-BjmrJCen.js";
import { n as t } from "./text.css-DDuHJ-lZ.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/section-heading/section-heading.css.ts
var i = "dozkjk0", a = "dozkjk1";
//#endregion
//#region src/components/section-heading/section-heading.tsx
function o({ action: o, children: s, className: c, eyebrowText: l, title: u, ...d }) {
	return /* @__PURE__ */ r("div", {
		...d,
		className: e(i, c),
		children: [/* @__PURE__ */ r("div", {
			className: a,
			children: [
				/* @__PURE__ */ n("p", {
					className: t,
					children: l
				}),
				typeof u == "string" ? /* @__PURE__ */ n("h2", { children: u }) : u,
				s
			]
		}), o]
	});
}
//#endregion
export { o as SectionHeading };

//# sourceMappingURL=section-heading.js.map